"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocietySupportRebalanced = void 0;
var PreludeCard_1 = require("./../../prelude/PreludeCard");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var Tags_1 = require("../../Tags");
var Units_1 = require("../../../Units");
var SelectHowToPayDeferred_1 = require("../../../deferredActions/SelectHowToPayDeferred");
var SocietySupportRebalanced = (function (_super) {
    __extends(SocietySupportRebalanced, _super);
    function SocietySupportRebalanced() {
        return _super.call(this, {
            name: CardName_1.CardName.SOCIETY_SUPPORT_REBALANCED,
            tags: [Tags_1.Tags.WILDCARD],
            productionBox: Units_1.Units.of({ plants: 1, heat: 1, energy: 1 }),
            metadata: {
                cardNumber: 'P31',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.plants(1).energy(1).heat(1);
                    }).br;
                    b.megacredits(-3);
                }),
                description: 'Increase your plant, energy and heat production 1 step. Pay 3 M€.',
            },
        }) || this;
    }
    SocietySupportRebalanced.prototype.canPlay = function (player) {
        return player.canAfford(3);
    };
    SocietySupportRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        player.addProduction(Resources_1.Resources.ENERGY, 1);
        player.addProduction(Resources_1.Resources.HEAT, 1);
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 3));
        return undefined;
    };
    return SocietySupportRebalanced;
}(PreludeCard_1.PreludeCard));
exports.SocietySupportRebalanced = SocietySupportRebalanced;
//# sourceMappingURL=SocietySupportRebalanced.js.map